import { APIResponseType } from '../types';
import apiService from './apiService';

type RequestParamsType = {
  endPoint: string;
  params: Record<string, any>; // Optional params
  page?: number; // Optional, default = 1
  pageSize?: number; // Optional, default = 20
  filters?: Record<string, any>; // Optional filters
};

/**
 * Fetches data from the API with pagination and filters.
 * @param endPoint - The API endpoint (e.g., 'users', 'products').
 * @param params - Additional query parameters.
 * @param page - Page number for pagination (default = 1).
 * @param pageSize - Number of items per page (default = 20).
 * @param filters - Additional filters to apply.
 * @param sort - Additional sort parameters to apply.
 * @returns A promise that resolves to the API response.
 */
export const fetchDataFromAPI = async (
  endPoint,
  params = {},
  page = 1,
  pageSize = 20,
  filters = '',
  sort = ''
): Promise<APIResponseType> => {
  try {
    // Combine all query parameters
    const queryParams = {
      ...params, // Existing params
      skip: (page - 1) * pageSize, // Calculate skip for pagination
      limit: pageSize, // Set page size
      filters, // Apply filters
      sort, // Apply sort
    };

    // Make the API call
    const response = await apiService.get<APIResponseType>(`/${endPoint}`, queryParams);
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // Re-throw the error for the caller to handle
  }
};

export const fetchAllDataFromAPI = async (
  endPoint,
  params = {},
): Promise<APIResponseType> => {
  try {
    const queryParams = {
      ...params,
    };

    // Make the API call
    const response = await apiService.get<APIResponseType>(`/${endPoint}`, queryParams);
    return response;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error; // Re-throw the error for the caller to handle
  }
};